import { useEffect, type FC } from 'react';
import Swap from '@components/swap';
import styles from './index.module.scss';

const Trade: FC = () => {
  useEffect(() => {
    document.body.classList.add(styles.swap_body!);
    return () => {
      document.body.classList.remove(styles.swap_body!);
    };
  }, []);

  return (
    <>
      <Swap />
    </>
  );
};

export default Trade;
